import { ChevronRight } from "lucide-react";
import {
  type EffortLevel,
  getQuadrant,
  type ImpactLevel,
  QUADRANT_COLORS,
} from "@/bizminer/App/PillarInsights/ImprovementLevers/shared/improvementLeverUtils.ts";
import type { BizminerImprovementLever } from "@/types/serializers";

interface GridPillProps {
  improvementLever: BizminerImprovementLever;
  onClick: () => void;
}

export default function GridPill({ improvementLever, onClick }: GridPillProps) {
  const quadrant = getQuadrant(
    improvementLever.impact as ImpactLevel,
    improvementLever.effort as EffortLevel,
  );
  const dotColor = QUADRANT_COLORS[quadrant];

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-2 p-2 bg-muted border border-border rounded-md text-sm text-foreground cursor-pointer transition-[background-color,border-color,box-shadow] hover:border-foreground/20 hover:bg-muted/70 w-full text-left"
    >
      <span className={`w-2 h-2 rounded-full flex-shrink-0 ${dotColor}`} />
      <span className="flex-1 leading-tight">{improvementLever.title}</span>
      <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
    </button>
  );
}
